import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ToastContainer, toast } from "react-toastify";
import "sweetalert2/src/sweetalert2.scss";
import Lightbox from "react-image-lightbox";
import moment from "moment";
//import filter modal
import FilterModal from "components/Modal/FilterModal";
import {
    getRequest,
    postRequest,
    deleteRequest,
    putRequest,
    postRequestForm,
    deleteConfirmationWords,
} from "components/Common/Utils";

import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import axios from "axios";

import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Spinner,
    Badge,
    UncontrolledTooltip,
    Modal,
    Button,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { change } from "redux-form";
import { id } from "date-fns/locale";

const filterObj = {
    first_name: "",
    last_name: "",
    gender: "",
    email: "",
    phone: "",
    country: "",
    nationality: "",
    bookingCode: "",
    bookingDate: "",
    agentEmail: "",
};

const ManufacturerTransactions = (props) => {
    const [modal_center, setmodal_center] = useState(false);
    const [Categorydata, setCategorydata] = useState([]);
    const [loader, setLoader] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [value, setValue] = React.useState(10);
    const [sort, setsort] = React.useState("");
    const [sortOrder, setsortOrder] = React.useState("desc");
    const [currentFPage, setCurrentFPage] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [sizePerPageOrg, setSizePerPage] = useState(10);
    const [image, setImage] = React.useState("");
    const [openLightbox, setOpenLightBox] = React.useState(false);
    const [sizeList, setSizeList] = useState([]);
    const [model, setModel] = useState(false);
    const [canCreate, setCanCreate] = useState(true);
    const [canEdit, setCanEdit] = useState(true);
    const [canDelete, setCanDelete] = useState(true);
    const [canExport, setCanExport] = useState(true);
    const [filter, setFilter] = useState({ ...filterObj });
    const [loader2, setLoader2] = useState(false);

    useEffect(() => {
        fetchTransactionsList();
    }, [currentPage]);

    useEffect(() => {
        fetchTransactionsList();
    }, [sort, sortOrder]);

    const GetValueOnChange = async (isActive, item) => {
        const payload = {
            id: item?._id,
            question: item?.question,
            answer: item?.answer,
            isPublished: isActive == true ? false : true,
            isDeleted: item?.isDeleted,
        }
        const res = await postRequest("support/quick-question/update", payload);
        if (res.status) {
            toast.success(res.message);
            fetchTransactionsList();
        } else {
            toast.error("Something went wrong");
            setLoader(false);
        }
    };
    const closeModal = () => {
        setModel(false);
    };

    const toggleModel = () => {
        console.log("toggleModel", model);
        setModel(!model);
    };

    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "pagination") {
            if (page != currentPage) {
                setCurrentPage(page);
                console.log("page", page);
            }
        }

        console.log("type", type);

        if (type === "search") {
            console.log("searchText", searchText);
        }
    };

    const showLightBox = (image) => {
        setImage(image);
        setOpenLightBox(true);
    };

    function SNoFormatter(cellContent, row, i) {
        return <>{i + 1}</>;
    }

    const columns = [
        {
            text: "S.NO",
            formatter: SNoFormatter,
            sort: false,
        },

        {
            dataField: "_id",
            text: "Transaction ID",
            sort: false,
        },
        {
            dataField: "productId",
            text: "Product ID",
            sort: false,
        },
        {
            text: "Product Name",
            sort: false,
            formatter: (cell, row) => (
                <>  {row?.productDetails?.name &&
                    <Link to={`product-details/${row?.productId}`} className="d-flex align-items-center justify-content-start text-start" style={{ gap: '10px' }}>
                        <span><img src={row?.productDetails?.images?.[0]} width='30px' /></span>
                        <span style={{ color: '#696464' }}>{row?.productDetails?.name}</span>
                    </Link>
                }
                </>
            ),
        },
        {
            text: "Manufacturers",
            sort: false,
            formatter: (cell, row) => (
                <div className="d-flex gap-2 align-items-center">
                    <Link to={`/manufacturers-details/${row?.manufacturerDetails?._id}`}>
                        <div style={{ width: '50px' }}><img src={row?.manufacturerDetails?.logo} width="50px" /></div>
                    </Link>
                    <div className="flex-product text-start">
                        <Link to={`/manufacturers-details/${row?.manufacturerDetails?._id}`} className="mb-0">{row?.manufacturerDetails?.companyName}</Link>
                        {/* <p className="mb-0">{row?.manufacturerDetails?.mobile}, </p> */}
                        <p className="mb-0">{row?.manufacturerDetails?.address}</p>
                    </div>
                </div>
            ),
        },

        {
            text: "Amount",
            sort: false,
            formatter: (cell, row) => (
                <>
                    <span>${row?.amount.toLocaleString()}</span>
                </>
            ),
        },

        // {
        //     dataField: "type",
        //     text: "Type",
        //     sort: false,
        // },
        {
            formatter: (cell, row) => (
                <span
                    style={{
                        color:
                            row?.status === "pending"
                                ? "orange"
                                : row?.status === "approved" || row?.status === "completed"
                                    ? "green"
                                    : row?.status === "rejected" || row?.status === 'cancelled'
                                        ? "red"
                                        : "black",
                    }}
                >
                    {row?.status.charAt(0).toUpperCase() + row?.status.slice(1)}
                </span>
            ),
            text: "Status",
            sort: false,
        },
        {
            text: "Created At",
            sort: false,
            dataField: 'created',
            formatter: (cell, row) => (
                <>{moment(row?.createdAt).format("DD-MM-YYYY hh:mm A")} </>
            ),
        },
        // {
        //     dataField: "order",
        //     text: "Order Details",
        //     sort: false,
        // },

        // {
        //     dataField: "actions",
        //     text: "Action",
        //     formatter: iconFormatter,
        //     sort: false,
        // },
    ];
    const handleChange = (event) => {
        console.log(event);
        setSizePerPage(event.target.value);
        if (currentPage != 1) {
            setCurrentPage(1);
        } else {
            fetchTransactionsList(event.target.value);
        }
    };
    const handlesorting = (event) => {
        setsort(event.target.value);
    };
    const handlesortOrder = (event) => {
        setsortOrder(event.target.value);
    };

    const handleReload = () => {
        setSearchText("");
    };

    function iconFormatter(cellContent, row) {
        return (
            <div className="d-flex gap-2">
                <button type="button" className=" btn btn-primary">
                    <Link
                        to={{
                            pathname: `/faq-update`,
                            state: { row },
                        }}
                    >
                        <i className="fal fa-edit fs-5 text-light"></i>
                    </Link>
                </button>

                <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => handlerdelete(row._id)}
                >
                    <i className="fal fa-trash  fs-5"></i>
                </button>
            </div>
        );
    }

    // const limit = 10;
    const fetchTransactionsList = async (limit = null) => {
        console.log(currentPage);
        setLoader(true);
        const payload = {
            limit: limit ? limit : sizePerPageOrg,
            page: currentPage,
            search: searchText,
            sortOrder: sortOrder,
            filterArgs: [
                {
                    type: "regex",
                    status: sort
                }
            ]
        };
        try {
            const response = await postRequest(`setting/admin-manufacturer-wallet-list`, payload);
            const data = response.data;
            setTotalPage(data?.count);
            // setSizePerPage(sizePerPageOrg)
            setCurrentFPage(currentPage);
            setCategorydata(data?.list || []);
        } catch (error) {
            console.log("Failed to fetch data:", error);
        } finally {
            setLoader(false);
        }
    };

    return (
        <>
            <React.Fragment>
                <ToastContainer />
                <Row>
                    <div className="col-md-6">
                        <div className="page-title-box">
                            <h4>Transactions Overview</h4>
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item active">Transactions Overview</li>:{" "}
                                <li className="breadcrumb-item">Manufacturer Wallet</li>
                            </ol>
                        </div>
                    </div>
                    <div className="col-md-6 text-end">

                        &nbsp;&nbsp;&nbsp;
                    </div>
                    <Col className="col-12">
                        <Card>
                            {loader ? (
                                <CardBody style={{ height: "100px" }}>
                                    <Spinner
                                        color="info"
                                        style={{
                                            height: "4rem",
                                            width: "4rem",
                                            position: "absolute",
                                            left: "50%",
                                        }}
                                    >
                                        Loading...
                                    </Spinner>
                                </CardBody>
                            ) : (
                                <CardBody className="table-shorting">
                                    {
                                        <PaginationProvider
                                            pagination={paginationFactory({
                                                page: currentFPage,
                                                sizePerPage: sizePerPageOrg,
                                                totalSize: totalPage,
                                                custom: true,
                                            })}
                                        >
                                            {({ paginationProps, paginationTableProps }) => (
                                                <>
                                                    <ToolkitProvider
                                                        keyField="_id"
                                                        data={Categorydata}
                                                        columns={columns}
                                                    >
                                                        {(props) => (
                                                            <Row>
                                                                <Col className="col-lg-12 d-flex mb-3">
                                                                    <label className="mb-0 text-label">
                                                                        Page Size
                                                                    </label>

                                                                    <select
                                                                        value={sizePerPageOrg}
                                                                        onChange={handleChange}
                                                                        className="form-select"
                                                                        style={{ width: "7%" }}
                                                                    >
                                                                        <option value="10">10</option>

                                                                        <option value="20">20</option>

                                                                        <option value="50">50</option>
                                                                    </select>

                                                                    <label className="mb-0 text-label ms-3">
                                                                        Sort Order:
                                                                    </label>
                                                                    <select
                                                                        value={sortOrder}
                                                                        onChange={handlesortOrder}
                                                                        className="form-select"
                                                                        style={{ width: "10%" }}
                                                                    >
                                                                        <option value="asc"> Ascending</option>
                                                                        <option value="desc">Descending</option>
                                                                    </select>

                                                                    <label className="mb-0 text-label ms-3">
                                                                        Sort By:
                                                                    </label>
                                                                    <select
                                                                        value={sort}
                                                                        onChange={handlesorting}
                                                                        className="form-select"
                                                                        style={{ width: "10%" }}
                                                                    >
                                                                        <option selected>Select Type</option>
                                                                        <option value="pending">Pending</option>
                                                                        <option value="approved">Approved</option>
                                                                        <option value="rejected">Rejected</option>
                                                                        <option value="completed">Completed</option>
                                                                        <option value="cancelled">Cancelled</option>
                                                                    </select>

                                                                    <div className="filter-item" style={{ width: '86.5%' }}>
                                                                        <input
                                                                            type="search"
                                                                            placeholder="Search"
                                                                            value={searchText}
                                                                            class="form-control"
                                                                            onChange={(e) =>
                                                                                setSearchText(e.target.value)
                                                                            }
                                                                            style={{ width: "30%" }}
                                                                        />
                                                                        <button
                                                                            onClick={() => {
                                                                                fetchTransactionsList();
                                                                            }}
                                                                            type="button"
                                                                            className="btn btn-primary mx-2"
                                                                        >
                                                                            Search
                                                                        </button>

                                                                        <button
                                                                            type="button"
                                                                            onClick={handleReload}
                                                                            className="btn btn-danger mx-2"
                                                                        >
                                                                            Reset
                                                                        </button>
                                                                        {/* <button
                                      type="button"
                                      onClick={toggleModel}
                                      className="btn btn-info"
                                    >
                                      Filter
                                    </button> */}
                                                                    </div>
                                                                </Col>

                                                                <Col className="col-lg-12 text-end">
                                                                    <BootstrapTable
                                                                        onTableChange={handleTableChange}
                                                                        remote={true}
                                                                        classes="table-striped"
                                                                        {...props.baseProps}
                                                                        {...paginationTableProps}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        )}
                                                    </ToolkitProvider>

                                                    <Row>
                                                        <Col className="col-lg-12 text-end">
                                                            <div className="text-md-right">
                                                                <PaginationListStandalone
                                                                    {...paginationProps}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </>
                                            )}
                                        </PaginationProvider>
                                    }
                                </CardBody>
                            )}
                        </Card>
                    </Col>
                </Row>
                {openLightbox && (
                    <>
                        <Lightbox
                            mainSrc={image}
                            onCloseRequest={() => setOpenLightBox(false)}
                            toolbarButtons={[
                                <button
                                    className="btn btn-primary"
                                    key="download"
                                    onClick={handleDownload}
                                >
                                    Download
                                </button>,
                            ]}
                        />
                    </>
                )}
            </React.Fragment>

        </>
    );
};

export default ManufacturerTransactions;
